import "@formatjs/intl-numberformat/polyfill-force";
import "@formatjs/intl-numberformat/locale-data/pt";
import "@formatjs/intl-numberformat/locale-data/es";
import "@formatjs/intl-numberformat/locale-data/en";
import "@formatjs/intl-datetimeformat/locale-data/pt";
import "@formatjs/intl-datetimeformat/locale-data/es";
import "@formatjs/intl-datetimeformat/locale-data/en";
import "@formatjs/intl-datetimeformat/add-all-tz";

export const loadDateTimeFormatPolyfill = async () => {
  if (typeof Intl === "undefined" || !Intl.DateTimeFormat?.prototype?.formatToParts) {
    await import("@formatjs/intl-datetimeformat/polyfill");
  }
};

export const loadNumberFormatPolyfill = async () => {
  if (typeof Intl === "undefined" || !Intl.NumberFormat?.prototype?.formatToParts) {
    await import("@formatjs/intl-numberformat/polyfill");
  }
};

export const loadIntlPolyfills = async () => {
  await Promise.all([loadDateTimeFormatPolyfill(), loadNumberFormatPolyfill()]);
};
